import React from 'react';
import Popover from "../common/components/popover/popover.js";
import { Carousel } from 'react-responsive-carousel';

const ImpactMobileView = ({ contributions, carbonOffsetImpact, treeGrowthYears, nightsOffset }) => {
    const treeMetric = `An average tree captures about 20kg of carbon dioxide per year, and about 1 tonne over its lifetime. By funding projects that offset carbon emissions, we are having the same impact as ${treeGrowthYears?.value} trees have in one year.`;


    return (
        <div className="mobile-show bg-primary py-3 mt-4 text-center">

            <Carousel dynamicHeight={false} showThumbs={false} showArrows={false} showStatus={false} infiniteLoop={true} autoPlay={true}>

                <div key="1" >
                    <div className="mb-3">
                        <div className="center w-100 px-3">
                            <div className="img-cover h-240px impact-flight w-100">

                            </div>
                            <div className="py-4 font-bold">
                                <h2>{nightsOffset}</h2>
                                <p>Nights made climate positive</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div key="2" >
                    <div className="mb-3">
                        <div className="center w-100 px-3">
                            <div className="img-cover h-240px impact-community w-100">

                            </div>
                            <div className="py-4 font-bold">
                                <h2>{contributions?.value && Math.floor(contributions.value).toLocaleString()}</h2>
                                <p>Travellers have taken action</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div key="3">
                    <div className="mb-3">
                        <div className="center w-100 px-3">
                            <div className="img-cover h-240px impact-CO2 w-100">

                            </div>
                            <div className="py-4 font-bold">
                                <h2>{carbonOffsetImpact?.value && Math.round(carbonOffsetImpact.value).toLocaleString()}</h2>
                                <p>{`${carbonOffsetImpact?.unit} of CO2 Offset`}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div key="4">
                    <div className="mb-3">
                        <div className="center w-100 px-3">
                            <div className="img-cover h-240px impact-trees w-100">
                            </div>
                            <div className="py-4 font-bold">
                            <h2>{treeGrowthYears?.value && Math.floor(treeGrowthYears.value).toLocaleString()}</h2>
                                <p><span className="mr-2">Tree Growth Years</span>
                                    <Popover content={treeMetric} >
                                        <svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24" width="20">
                                            <path d="M0 0h24v24H0z" fill="none" />
                                            <path fill="currentColor" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z" />
                                        </svg>
                                    </Popover>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

            </Carousel>
        </div>
    );
};

export default ImpactMobileView;